import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';
import Swal from 'sweetalert2';
import { glosarioProceso1 } from '../utils/glosarioContratacion';

//Funciones
import { deleteFile, singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const crearEmpleadoNomina = functionsHttpsCallable('ape_crearEmpleadoNomina');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalAdjutno = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [updFile, setUpdFile] = useState([]);

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const handleUpdate = async () => {
        props.setLoading(true);
        if (glosarioProceso1[props.newState].id === 'REPORTE_NOMINA') {
            const nominaBody = {
                codigoAPE: props.id
            };
            await crearEmpleadoNomina(nominaBody);
            const body = {
                cod_soli: props.id,
                cod_empr: userData.codigoEmpresa,
                data: {
                    cmp_stat: glosarioProceso1[props.newState].id
                }
            }
            await actualizarAPE(body)
            Swal.fire({
                title: "Envio a nómina correcto",
                text: "El empleado ha sido reportado a nómina correctamente",
                icon: "success"
            });

        }
        else {
            const body = {
                cod_soli: props.id,
                cod_empr: userData.codigoEmpresa,
                data: {
                    cmp_stat: glosarioProceso1[props.newState].nextState
                }
            }
            const req = await actualizarAPE(body)
            props.setLoading(false)
            props.toggle();
            Swal.fire({
                title: "Error al enviar a nómina",
                text: "Ocurrió un error al enviar a nomina",
                icon: "error"
            });

        }
        props.setLoading(false);
    }
    
    useEffect(() => {        
    }, [])

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                onClick={() => handleUpdate()}
                buttonLoading={false}
                title={`${glosarioProceso1[props.newState].name}`}
            >
                <Row>
                    {glosarioProceso1[props.newState] !== undefined && glosarioProceso1[props.newState].attachments !== undefined ?
                        glosarioProceso1[props.newState].attachments.map((doc, index) => {
                            return (
                                <Col key={`col1_${index}`} lg='3' md='6' xs="12">
                                    <AttachCardV2
                                        id={`${doc.key}`}
                                        apeId={props.id}
                                        file={fileExist(`${doc.key}`).file}
                                        subText={`${doc.name}`}
                                        attached={fileReadyToUpload(`${doc.key}`) || fileExist(`${doc.key}`).exists}
                                        fileList={props.fileList}
                                        setLoading={(e) => props.setLoading(e)}
                                        setFileList={(e) => { props.setFileList(e) }}
                                    />
                                </Col>
                            )
                        }) : <a style={{ justifyContent: 'center' }}>Desea actualizar el estado a <strong>{glosarioProceso1[props.newState].name}</strong></a>}
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalAdjutno);